import { useReveal, reveal } from '../../hooks/useReveal.js';

/**
 * Rises and fades its children in the first time they reach the viewport.
 *
 * Used sparingly and on purpose. Animating every section of a marketing page
 * is the usual mistake: it delays the content a visitor came for, it makes a
 * long page feel slow rather than polished, and by the fourth repeat it reads
 * as decoration. A few well-placed moments do more than a page-wide effect.
 *
 * `as` keeps the markup honest — a reveal around list items should still be a
 * list item, not a div wrapped around one.
 */
export default function Reveal({ as: Tag = 'div', delay = 0, className = '', children, ...rest }) {
  const [ref, shown] = useReveal();
  const r = reveal(shown, delay);

  return (
    <Tag ref={ref} className={`${r.className} ${className}`} style={r.style} {...rest}>
      {children}
    </Tag>
  );
}
